import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Hidden } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import FilterView from './FilterView'
import { PlaceBlackIcon, LocationOnWhiteIcon, RisedHandIcon, TuneWhiteIcon } from '../../components/icons';
import OfferItem from './OfferItem';
import CustomizedCircularProgress from '../../components/CircularProgress'
import ButtonCustom from '../../components/ButtonCustom';
import InfiniteScroll from 'react-infinite-scroll-component';

const heightCoverItem = 200
const heightItem = 350;
const styles = theme => ({
    container: {
        position: 'relative',
    },
    list:{
        marginTop: theme.spacing(1)
    },
    handIcon: {
        height: 35,
    },
    buttonMap: {
        ...theme.palette.button.primary,
        width: theme.spacing(40),
        height: theme.spacing(10),
        boxShadow: 'none',
        borderRadius: theme.spacing(8),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        padding: theme.spacing(1, 1, 1, 3),
        '&:hover': {
            opacity: 0.5,
        },

        // position: 'absolute',
        // top: theme.spacing(0),
        // right: theme.spacing(3),
    },
    buttonMap_small: {
        ...theme.palette.button.primary,
        width: theme.spacing(10),
        height: theme.spacing(10),
        boxShadow: 'none',
        borderRadius: theme.spacing(8),
        borderColor: theme.palette.background.transparent,
        opacity: 1,
        cursor: "pointer",
        '&:hover': {
            opacity: 0.5,
        },

        // position: 'absolute',
        // top: theme.spacing(0),
        // right: theme.spacing(2),
    },
    midHeader:{
        position: 'absolute',
        top: theme.spacing(0),
        right: theme.spacing(2),
    },
    button_Filter: {
        marginRight: theme.spacing(2),
        boxShadow: 'none',
        opacity: 1,
        cursor: "pointer",
        '&:hover': {
            opacity: 0.5,
        },
    },
});
function OffersView(props){
    const { classes, t, onShowOfferDetail, offers, filter_options, onOpenFilter, filterSelected, onClearFilter, onShowMap,showLoading, hasMore, showLoadMore } = props;
    //console.log('OffersView offers=',offers)
    //var OffersMap = Array.from(offers)
    //console.log('OffersView showLoadMore=',showLoadMore)
    //console.log('OffersView showLoad hasMore=',hasMore)
    return (
        <Container>
            <Grid xs={12} item className={classes.container}>
                {/* {filter_options? <FilterView filter_options={filter_options} onSelectFilter={onSelectFilter} filterSelected={filterSelected} onClearFilter={onClearFilter}/>:null} */}
                <Grid xs={12} item container>
                    <Typo mg_left_xl variant='h2' color='onPrimary'>{t('offers_title')}&nbsp;</Typo>
                    <RisedHandIcon className={classes.handIcon} />
                </Grid>
                {showLoading&& <CustomizedCircularProgress />}
                <Grid xs={12} item className={classes.list}>
                    <InfiniteScroll
                        dataLength={offers.length} //This is important field to render the next data
                        next={props.handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                    >
                        <Grid xs={12} item container className={classes.list}>
                            {offers.map((item, index) => (
                                <OfferItem key={index} item = {item} onShowOfferDetail={onShowOfferDetail}/>
                            ))}
                        </Grid>
                    </InfiniteScroll>
                </Grid>
                {/* <Hidden mdUp>
                <Grid item container className={classes.midHeader} direction='row' justify='flex-end' alignItems='center'>
                        <Grid item className={classes.button_Filter}>
                            <TuneWhiteIcon/>
                        </Grid>   
                    <Grid item container className={classes.buttonMap_small} onClick={onShowMap} direction='row' justify='center' alignItems='center'>
                            <PlaceBlackIcon/>
                    </Grid>
                </Grid>
                </Hidden> */}
                {/* <Hidden smDown> */}
                    {!showLoading && <Grid item container className={classes.midHeader} direction='row' justify='flex-end' alignItems='center'>
                        <Grid item className={classes.button_Filter} onClick={onOpenFilter}>
                            <TuneWhiteIcon/>
                        </Grid>        
                    
                        <Grid item container className={classes.buttonMap} onClick={onShowMap} direction='row' justify='center' alignItems='center'>
                            <Grid xs={1} item >
                                <LocationOnWhiteIcon/>
                            </Grid>
                            <Grid xs={11} item>
                                <Typo variant='subtitle2'>{t('show_on_map')}</Typo>
                            </Grid>
                        </Grid>
                    </Grid>}
                {/* </Hidden> */}
            </Grid>
        </Container>
    );
}

export default withStyles(styles)(withTranslation()(OffersView));